import React, { useEffect, useState } from "react";
import api from "../../services/api";

const typeConfig = {
  "Client":      { bg: "#E6F1FB", text: "#185FA5", icon: "👤" },
  "Commercial":  { bg: "#E1F5EE", text: "#0f6e56", icon: "💼" },
  "Superviseur": { bg: "#f3e8ff", text: "#7c3aed", icon: "👔" },
};

const actionConfig = {
  "Archivage":    { bg: "#fef2f2", text: "#dc2626" },
  "Reactivation": { bg: "#f0fdf4", text: "#16a34a" },
};

const Archivage = () => {
  const [historique, setHistorique] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtreType, setFiltreType] = useState("tous");
  const [filtreAction, setFiltreAction] = useState("tous");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get("/commercials/archivage/historique");
        setHistorique(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const formatDate = (dateStr) => new Date(dateStr).toLocaleString("fr-FR", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit"
  });

  const historiqueFiltré = historique.filter(h => {
    const matchType   = filtreType === "tous" || h.entite_type === filtreType;
    const matchAction = filtreAction === "tous" || h.action === filtreAction;
    const matchSearch = search === "" ||
      String(h.entite_id).includes(search) ||
      (h.commentaire || "").toLowerCase().includes(search.toLowerCase()) ||
      (h.auteur_role || "").toLowerCase().includes(search.toLowerCase());
    return matchType && matchAction && matchSearch;
  });

  return (
    <>
      {/* Header */}
      <div style={{ marginBottom: "1.5rem" }}>
        <h1 style={{ fontSize: "18px", fontWeight: "500", color: "#111827", margin: 0 }}>Historique d'archivage</h1>
        <p style={{ fontSize: "13px", color: "#6b7280", margin: "4px 0 0" }}>
          {historique.length} action(s) enregistrée(s)
        </p>
      </div>

      {/* Filtres */}
      <div style={{ display: "flex", gap: "0.75rem", marginBottom: "1.25rem", flexWrap: "wrap", alignItems: "center" }}>
        {/* Recherche */}
        <div style={{ flex: 1, minWidth: "200px", position: "relative" }}>
          <svg width="14" height="14" fill="none" stroke="#9ca3af" strokeWidth="2" viewBox="0 0 24 24"
            style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)" }}>
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <input type="text" placeholder="Rechercher..." value={search} onChange={e => setSearch(e.target.value)}
            style={{ width: "100%", padding: "0.65rem 0.9rem 0.65rem 2.25rem", border: "1px solid #e5e7eb", borderRadius: "9999px", fontSize: "13px", outline: "none", boxSizing: "border-box", background: "white" }} />
        </div>

        {/* Filtre type */}
        <div style={{ display: "flex", gap: "6px" }}>
          {["tous", "Client", "Commercial", "Superviseur"].map(t => (
            <button key={t} onClick={() => setFiltreType(t)} style={{ padding: "0.4rem 0.9rem", borderRadius: "9999px", fontSize: "12px", border: filtreType === t ? "none" : "1px solid #e5e7eb", backgroundColor: filtreType === t ? "#7c3aed" : "white", color: filtreType === t ? "white" : "#6b7280", cursor: "pointer" }}>
              {t === "tous" ? "Tous" : t}
            </button>
          ))}
        </div>

        {/* Filtre action */}
        <div style={{ display: "flex", gap: "6px" }}>
          {["tous", "Archivage", "Reactivation"].map(a => (
            <button key={a} onClick={() => setFiltreAction(a)} style={{ padding: "0.4rem 0.9rem", borderRadius: "9999px", fontSize: "12px", border: filtreAction === a ? "none" : "1px solid #e5e7eb", backgroundColor: filtreAction === a ? (a === "Archivage" ? "#dc2626" : "#16a34a") : "white", color: filtreAction === a ? "white" : "#6b7280", cursor: "pointer" }}>
              {a === "tous" ? "Toutes actions" : a === "Archivage" ? "Archivages" : "Réactivations"}
            </button>
          ))}
        </div>
      </div>

      {/* Liste */}
      <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", overflow: "hidden" }}>
        {loading ? (
          <div style={{ padding: "3rem", textAlign: "center", color: "#6b7280" }}>Chargement...</div>
        ) : historiqueFiltré.length === 0 ? (
          <div style={{ padding: "3rem", textAlign: "center" }}>
            <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>📋</div>
            <p style={{ color: "#6b7280", fontSize: "14px" }}>Aucun historique trouvé</p>
          </div>
        ) : (
          historiqueFiltré.map((h, i) => {
            const tc = typeConfig[h.entite_type]   || { bg: "#f3f4f6", text: "#6b7280", icon: "?" };
            const ac = actionConfig[h.action]       || { bg: "#f3f4f6", text: "#6b7280" };
            return (
              <div key={h.id} style={{ display: "flex", alignItems: "flex-start", gap: "12px", padding: "1rem 1.25rem", borderBottom: i < historiqueFiltré.length - 1 ? "0.5px solid #f3f4f6" : "none", flexWrap: "wrap" }}>
                {/* Icône type */}
                <div style={{ width: "38px", height: "38px", borderRadius: "10px", backgroundColor: tc.bg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px", flexShrink: 0 }}>
                  {tc.icon}
                </div>

                {/* Contenu */}
                <div style={{ flex: 1, minWidth: "200px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px", flexWrap: "wrap" }}>
                    <span style={{ fontSize: "12px", padding: "2px 8px", borderRadius: "6px", backgroundColor: tc.bg, color: tc.text, fontWeight: "500" }}>
                      {h.entite_type} #{h.entite_id}
                    </span>
                    <span style={{ fontSize: "12px", padding: "2px 8px", borderRadius: "6px", backgroundColor: ac.bg, color: ac.text, fontWeight: "500" }}>
                      {h.action === "Reactivation" ? "Réactivation" : h.action}
                    </span>
                    <span style={{ fontSize: "11px", color: "#9ca3af" }}>
                      par {h.auteur_role} #{h.auteur_id}
                    </span>
                  </div>
                  {h.commentaire && (
                    <p style={{ fontSize: "13px", color: "#374151", margin: "0 0 4px" }}>
                      {h.commentaire}
                    </p>
                  )}
                  <span style={{ fontSize: "11px", color: "#9ca3af" }}>{formatDate(h.date_action)}</span>
                </div>
              </div>
            );
          })
        )}
      </div>
    </>
  );
};

export default Archivage;